import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-elastic-search',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule
  ],
  templateUrl: './elastic-search.component.html',
  styleUrl: './elastic-search.component.scss'
})
export class ElasticSearchComponent {

}
